import {
  SET_PS_GAME_NAMES,
  SET_PS_GAME_IMAGES,
  SET_PS_GAME_POLA,
  SET_GAME_ISLOADING,
  SET_GAME_ISERROR
} from '../actionTypes';

const initialState = {
  psNames: [],
  psImages: [],
  psPolas: [],
  nameAndImagesIsLoading: true,
  isError: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PS_GAME_NAMES:
      return { ...state, psNames: action.payload }
    case SET_PS_GAME_IMAGES:
      return { ...state, psImages: action.payload };
    case SET_PS_GAME_POLA:
      return { ...state, psPolas: action.payload };
    case SET_GAME_ISLOADING:
      return { ...state, nameAndImagesIsLoading: action.payload };
    case SET_GAME_ISERROR:
      return { ...state, isError: action.payload };
    default:
      return state;
  };
};

export default reducer;